import { HTTPClient } from '@weike/toolkit'
import Config from '../config'

const wkHttp = new HTTPClient({ baseURL: Config.BASE_CRM_API_URL }, 0)

const cmsHttp = new HTTPClient({ baseURL: Config.CRM_API_URL }, '0000')



export function getRefundProgress(params) {
  return wkHttp.get('/__work_order/api/customer/refund_progress/', {
    params,
  }).then(res => {
      return {
        server_date: res.server_date,
        ...res.data,
      }
    })
}

/**
 * https://console-docs.apipost.cn/preview/fd2aa20048430fbd/e3a184a1a1fc2ea2?target_id=652fdd5c-b5ec-4b4a-84b9-d990244bcd04
 * 申请售后检查
 * @param order_id
 */
export function checkApplyAfterSales(order_id) {
  return cmsHttp.post('/mini_cms/v1/api/after_sales.apply.check', {
    order_id: order_id, //订单id
  })
}



// WEBPACK FOOTER //
// ./src/services/order.js